import React from 'react';

export interface PageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function PageHeader({ title, subtitle, actions, style, ...rest }: PageHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        ...style,
      }}
      {...rest}
    >
      <div>
        <h1 style={{ fontSize: '20px', fontWeight: 700, color: 'var(--text, #1A2027)', margin: 0 }}>{title}</h1>
        {subtitle ? (
          <p style={{ fontSize: '13px', color: 'var(--text-muted, #5B6770)', margin: 0 }}>{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div style={{ display: 'flex', gap: '8px' }}>{actions}</div> : null}
    </div>
  );
}

export default PageHeader;
